export const useStore = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  return userData;
};
